import FeatureSnippetActions from './FeatureSnippetActions';

export default FeatureSnippetActions;
export { FeatureSnippetActions };
